<template>
	<div>
		<h2>Troubleshooting</h2>
		<ul class="nav nav-tabs">
		  <li class="nav-item">
		    <router-link class="nav-link" to="/troubleshooting" v-bind:class="{active : user}" href="#">Users</router-link>
		  </li>
		  <li class="nav-item">
		    <router-link class="nav-link" to="/troubleshootingloc" v-bind:class="{active : location}" href="#">Location</router-link>
		  </li>
		</ul>
	</div>
</template>
<script>
export default{
	props: {
		'tab': {
			type: String,
			default: ''
		}
	},
	computed: {
		user () {
			console.log('TAB', this.tab)
			return this.tab === 'user'
		},
		location () {
			return this.tab === 'location'
		}
	}
}
</script>
<style></style>



// WEBPACK FOOTER //
// TroubleshootingMenu.vue?10097060